/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  AssistantListApiV1AssistantGetQueryResponse,
  AssistantListApiV1AssistantGetQueryParams,
  AssistantListApiV1AssistantGetHeaderParams,
  AssistantListApiV1AssistantGet422,
} from '../../types/AssistantListApiV1AssistantGet.ts'
import type { InfiniteData, QueryKey, QueryClient, InfiniteQueryObserverOptions, UseInfiniteQueryResult } from '@tanstack/react-query'
import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

export const assistantListApiV1AssistantGetInfiniteQueryKey = (params?: AssistantListApiV1AssistantGetQueryParams) =>
  [{ url: '/api/v1/assistant' }, ...(params ? [params] : [])] as const

export type AssistantListApiV1AssistantGetInfiniteQueryKey = ReturnType<typeof assistantListApiV1AssistantGetInfiniteQueryKey>

/**
 * @summary Assistant List
 * {@link /api/v1/assistant}
 */
export async function assistantListApiV1AssistantGetInfinite(
  params?: AssistantListApiV1AssistantGetQueryParams,
  headers?: AssistantListApiV1AssistantGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<AssistantListApiV1AssistantGetQueryResponse, ResponseErrorConfig<AssistantListApiV1AssistantGet422>, unknown>({
    method: 'GET',
    url: `/api/v1/assistant`,
    params,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  })
  return res.data
}

export function assistantListApiV1AssistantGetInfiniteQueryOptions(
  params?: AssistantListApiV1AssistantGetQueryParams,
  headers?: AssistantListApiV1AssistantGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = assistantListApiV1AssistantGetInfiniteQueryKey(params)
  return infiniteQueryOptions<
    AssistantListApiV1AssistantGetQueryResponse,
    ResponseErrorConfig<AssistantListApiV1AssistantGet422>,
    AssistantListApiV1AssistantGetQueryResponse,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: async ({ signal, pageParam }) => {
      config.signal = signal

      if (params) {
        params['offset'] = pageParam as unknown as AssistantListApiV1AssistantGetQueryParams['offset']
      }
      return assistantListApiV1AssistantGetInfinite(params, headers, config)
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => (Array.isArray(lastPage) && lastPage.length === 0 ? undefined : lastPageParam + 1),
    getPreviousPageParam: (_firstPage, _allPages, firstPageParam) => (firstPageParam <= 1 ? undefined : firstPageParam - 1),
  })
}

/**
 * @summary Assistant List
 * {@link /api/v1/assistant}
 */
export function useAssistantListApiV1AssistantGetInfinite<
  TData = InfiniteData<AssistantListApiV1AssistantGetQueryResponse>,
  TQueryData = AssistantListApiV1AssistantGetQueryResponse,
  TQueryKey extends QueryKey = AssistantListApiV1AssistantGetInfiniteQueryKey,
>(
  params?: AssistantListApiV1AssistantGetQueryParams,
  headers?: AssistantListApiV1AssistantGetHeaderParams,
  options: {
    query?: Partial<
      InfiniteQueryObserverOptions<AssistantListApiV1AssistantGetQueryResponse, ResponseErrorConfig<AssistantListApiV1AssistantGet422>, TData, TQueryKey>
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? assistantListApiV1AssistantGetInfiniteQueryKey(params)

  const query = useInfiniteQuery(
    {
      ...assistantListApiV1AssistantGetInfiniteQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as InfiniteQueryObserverOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, ResponseErrorConfig<AssistantListApiV1AssistantGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}